import {
    UR_AccountExecutive,
    UR_Closer,
    UR_LoanOfficer,
    UR_LoanOfficerManager,
    UR_LoanProcessor,
    UR_Owner,
    UR_PriceEngineUser,
    UR_RealEstateAgent,
    UR_SuperAdmin,
    UR_TrainingStaff,
    UR_Underwriter,
} from './State'

export const USER_ROLE_DISPLAY_NAMES = {
    [UR_LoanOfficer]: 'Loan Officer',
    [UR_LoanOfficerManager]: 'LO Manager',
    [UR_Owner]: 'Owner',
    [UR_RealEstateAgent]: 'Real Estate Agent',
    [UR_LoanProcessor]: 'Processor',
    [UR_PriceEngineUser]: 'Price Engine',
    [UR_Underwriter]: 'Underwriter',
    [UR_Closer]: 'Closer',
    [UR_TrainingStaff]: 'Training',
    [UR_AccountExecutive]: 'Acct Exec',
    [UR_SuperAdmin]: 'Super Admin',
}

export function getUserRoleDisplayName(role) {
    return USER_ROLE_DISPLAY_NAMES[role] || role
}
